import { login, validatorCaptchaImage } from '@/api/loginApi'
import router from '@/router'
import { setTokenTime, setTokenLoginType } from '@/utils/auth'
import { ElLoading, ElMessage } from 'element-plus'
import { nextTick } from 'vue'
import store from '..'
export default {
    namespaced: true,

    state: () => ({
        token: localStorage.getItem('token') || '',
        siderType: true,
        lang: localStorage.getItem('lang') || 'zh',
        tabsList: [],
        accessToken: localStorage.getItem('UAccessToken') || '',
        refreshToken: localStorage.getItem('URefreshToken') || '',
        expireTime: localStorage.getItem('UExpireTime') || '',
        refreshImgCode: true
    }),
    mutations: {
        setToken(state?: any, token?: any) {
            state.token = token
            localStorage.setItem('token', token)
        },
        setUAccessToken(state?: any, accessToken?: any) {
            state.accessToken = accessToken
            localStorage.setItem('UAccessToken', accessToken)
        },
        setURefreshToken(state?: any, refreshToken?: any) {
            state.refreshToken = refreshToken
            localStorage.setItem('URefreshToken', refreshToken)
        },
        setUExpireTime(state?: any, expireTime?: any) {
            state.expireTime = expireTime
            localStorage.setItem('UExpireTime', expireTime)
        },
        changeSiderType(state: any) {
            state.siderType = !state.siderType
        },
        changLang(state: any, lang: any) {
            state.lang = lang
        },
        changeSidebarLogo(state: any, sidebarLogoType: any) {
            console.log(sidebarLogoType)
            state.sidebarLogoType = sidebarLogoType
        },
        changeMoshi(state: any, moshiNum: any) {
            state.moshiNum = moshiNum
        },
        setTabsList(state: any, tab: any) {
            // 判断是否存在 存在就retrun
            if (state.tabsList.some((item: { path: any }) => item.path === tab.path || tab.path === '/login')) return
            // if(tab.path=='/login')return
            state.tabsList.push(tab)
        },
        setRemoveTab(state: any, param: any) {
            state.tabsList = param
        },
        changeRefreshImgCode(state: any) {
            state.refreshImgCode = !state.refreshImgCode
        }
    },
    actions: {
        async login({ commit }: any, userInfo: any) {
            // 显示加载提示
            const loadingInstance = ElLoading.service({
                text: '正在登录,请稍后....',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            try {
                // 验证验证码
                // const captchaRes: any = await validatorCaptchaImage(userInfo.smsCode) // 假设这是你验证验证码的函数
                // if (captchaRes.code !== 200) {
                //     ElMessage({ message: captchaRes.message, type: 'error' })
                //     loadingInstance.close()
                //     return
                // }
                // 执行登录
                const loginRes: any = await login(userInfo) // 假设这是你调用登录API的函数
                if (loginRes.code === 200) {
                    commit('setToken', loginRes.token)
                    setTokenTime()
                    setTokenLoginType(0)

                    // 获取用户信息并设置路由
                    const { roles } = await store.dispatch('user/getInfo') // 确保user/getInfo返回了roles
                    if (roles.includes('big:screen')) {
                        router.replace('/screen')
                    } else {
                        router.replace('/')
                    }

                    // 加载完成后关闭提示
                    nextTick(() => {
                        loadingInstance.close()
                    })
                } else {
                    ElMessage({ message: loginRes.message, type: 'error' })
                    loadingInstance.close()
                    commit('changeRefreshImgCode')
                }
            } catch (error) {
                console.error('登录失败:', error)
                // ElMessage({ message: '登录失败，请稍后再试', type: 'error' })
                if (loadingInstance) {
                    loadingInstance.close()
                }
            }
        },
        // 退出
        logout({ commit }: any) {
            commit('setToken', '')
            commit('setRemoveTab', [])
            // localStorage.clear()
            localStorage.removeItem('tokenTime')
            localStorage.removeItem('token')
            sessionStorage.clear()

            router.replace('/login')
            // window.location.reload()
        }
    }
}
